module.exports = __webpack_public_path__ + "static/media/car-wash.f7a4f06e.svg";